import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { FiscalEventInterface } from '@app/interface/fiscal-event';
import { DatePipe } from '@angular/common';
import { Organizations } from '@app/interface/organizations';

export interface FiscalEventDetailData {
  fiscalEvent: FiscalEventInterface;
  organization?: Organizations | null;
}

@Component({
  selector: 'izy-fiscal-event-details',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatCardModule,
  ],
  templateUrl: './fiscal-event-details.component.html',
  styleUrl: './fiscal-event-details.component.scss',
  providers: [DatePipe],
})
export class FiscalEventDetailsComponent {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FiscalEventDetailsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: FiscalEventDetailData,
    private datePipe: DatePipe,
  ) {}

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  get eventExplanationText(): string {
    const event = this.data.fiscalEvent;
    const type = event.type || '';
    const dateFormatted = this.datePipe.transform(event.date, 'dd/MM/yyyy');
    const year = Number(this.datePipe.transform(event.date, 'yyyy'));

    const explanations: { [key: string]: string } = {
      TASSE: `Questo pagamento è dovuto entro il ${dateFormatted} per un importo di ${event.amount}€. Si tratta del calcolo della tua Imposta Sostitutiva stabilita dalla normativa vigente per il regime forfettario, effettuato sull'imponibile per l'anno precedente (${year - 1}) a seconda del tuo Coefficiente di redditività calcolato in base al codice Ateco.`,
      CONTRIBUTI: `Questo pagamento è dovuto entro il ${dateFormatted} per un importo di ${event.amount}€. Si tratta del calcolo contributi effettuato secondo la normativa vigente. Questo importo varia a seconda della cassa di previdenza collegata alla tua Partita Iva, nel tuo caso ${this.data.organization?.inps_fund_type || 'Gestione separata INPS'}. Il calcolo viene effettuato sull'imponibile per l'anno precedente (${year - 1}).`,
      CREDITO: `Questo è un credito generato per un importo di ${-event.amount}€. Si genera per effetto dell'Imposta Sostitutiva che hai versato l'anno precedente (${year - 1}) e che indicato come effettvamente pagato. Non devi fare altro in questo caso, questa voce è già stata incomporata nelle voci successive per questo anno.`,
    };

    return (
      explanations[type] ||
      `L'evento "${event.name || 'sconosciuto'}" è programmato per il ${dateFormatted} con un importo di ${event.amount}€. Verificare i dettagli specifici per questo tipo di scadenza.`
    );
  }

  closeBottomSheet(): void {
    this._bottomSheetRef.dismiss();
  }
}
